var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticStyle:{"display":"flex","align-items":"center"}},[_c('kl-label',{staticStyle:{"margin-right":"4px"},attrs:{"title":_vm.title,"icon":_vm.icon}}),_c('kl-label',{attrs:{"title":_vm.value,"bold":_vm.bold,"type":_vm.type}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }